var map = {
	"./al.json": [
		3525,
		525
	],
	"./ch.json": [
		3871,
		871
	],
	"./cz.json": [
		2985,
		985
	],
	"./de.json": [
		6679,
		679
	],
	"./en.json": [
		8508,
		127
	],
	"./es.json": [
		2968,
		968
	],
	"./fr.json": [
		6956,
		956
	],
	"./hu.json": [
		3771,
		771
	],
	"./it.json": [
		7301,
		301
	],
	"./pl.json": [
		136,
		136
	],
	"./pt.json": [
		736,
		736
	],
	"./ro.json": [
		4135,
		135
	],
	"./rs.json": [
		5395,
		395
	],
	"./tr.json": [
		5610,
		610
	],
	"./ua.json": [
		1274,
		274
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1985;
module.exports = webpackAsyncContext;